module.exports = __webpack_public_path__ + "img/[哈欠].fc976db2.svg";